@if (data) {
  <div [class]="data.isEqualSection ? 'container-sm' : 'container-xxl'">
    <div class="row">
      @switch (data.teasers.length) {
        @case (1) {
          <mb-card
            ngSkipHydration
            (click)="openCardMedia(data.teasers[0])"
            class="col-12 single-card"
            [class.is-equal]="data.isEqualSection"
            [data]="data.teasers[0]"
            [layouts]="largeLayouts"
            [actions]="data.teasers[0].actions || []"
            alignContent="bottom"
          >
            <figure>
              <mb-media [media]="data.teasers[0].media" [hoverplay]="true"></mb-media>
            </figure>
          </mb-card>
        }
        @case (2) {
          @for (item of data.teasers; track $index) {
            <div class="col-12 col-sm-6 two-cards" [class.is-equal]="data.isEqualSection">
              <mb-card
                ngSkipHydration
                (click)="openCardMedia(item)"
                [data]="item"
                [layouts]="smallLayout"
                [actions]="item.actions"
                [alignContents]="smallAlignments"
              >
                <figure>
                  <mb-media [media]="item.media" [hoverplay]="true"></mb-media>
                </figure>
              </mb-card>
            </div>
          }
        }
        @default {
          <div class="teaser-container three-cards">
            <mb-card
              ngSkipHydration
              (click)="openCardMedia(data.teasers[0])"
              [data]="data.teasers[0]"
              [layouts]="largeLayouts"
              [actions]="data.teasers[0].actions"
              alignContent="bottom"
            >
              <figure>
                <mb-media [media]="data.teasers[0].media" [hoverplay]="true"></mb-media>
              </figure>
            </mb-card>
            <mb-card
              ngSkipHydration
              (click)="openCardMedia(data.teasers[1])"
              [data]="data.teasers[1]"
              [layouts]="smallLayout"
              [actions]="data.teasers[1].actions"
              [alignContents]="smallAlignments"
            >
              <figure>
                <mb-media [media]="data.teasers[1].media" [hoverplay]="true"></mb-media>
              </figure>
            </mb-card>
            <mb-card
              ngSkipHydration
              (click)="openCardMedia(data.teasers[2])"
              [data]="data.teasers[2]"
              [layouts]="smallLayout"
              [actions]="data.teasers[2].actions"
              [alignContents]="smallAlignments"
            >
              <figure>
                <mb-media [media]="data.teasers[2].media" [hoverplay]="true"></mb-media>
              </figure>
            </mb-card>
          </div>
        }
      }
    </div>
  </div>
}
